import React, { useEffect, useRef, useState } from "react";
import Typography from "@mui/material/Typography";
import { CircularProgress, Tooltip } from "@mui/material";
import { CardActionArea } from "@mui/material";
import axios from "axios";
import {
  FaAnglesLeft,
  FaAnglesRight,
  FaAngleLeft,
  FaBuilding,
} from "react-icons/fa6";
import { useDispatch } from "react-redux";
import {
  companies,
  companies_non_mask,
  companyapproval,
  deletemycompany,
  dropDowns,
  mycompanies,
} from "../store/reducers";
import Map from "./Map";
import Filter from "./Filter";
import FSC from "../assets/FSC.jpg";
import ATFS from "../assets/ATFS.png";
import AllMapAddress from "./AllMapAddress";
import newTab from "../assets/new-tab.jpg";
import PEFC from "../assets/PEFC.jpg";
import SFI from "../assets/SFI.png";
import { FaEdit } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { IoCall } from "react-icons/io5";
import { IoIosMail } from "react-icons/io";
import MenuButton from "./MenuButton";
import { RiDeleteBin6Fill } from "react-icons/ri";
import { toast } from "react-toastify";
import Detail from "./Detail";
import { decryptAndRetrieveData } from "./login/encript-decript";
import { RiCloseCircleLine } from "react-icons/ri";
import { MdOutlineCheckCircle } from "react-icons/md";
import { IoMdCloseCircleOutline } from "react-icons/io";
import { FiDownload } from "react-icons/fi";

function Companies({ myCompanyRoute, dragable }) {
  const [click, setclick] = useState(false);
  const [page, setpage] = useState(1);
  const [company, setcompany] = useState();
  const [selectcompany, setselectcompany] = useState();
  const [loading, setloading] = useState(false);
  const [index, setIndex] = useState(0);
  const [isAdmin, setIsAdmin] = useState(false);
  const user = decryptAndRetrieveData("isAuth", "123456789");
  const token = localStorage.getItem("accessToken");

  let usertype;
  if (user && token) {
    const decodedToken = JSON.parse(atob(token.split(".")[1]));
    const user_type = decodedToken["custom:user_type"];
    usertype = user_type;
  }

  // Check if user is admin - checks both localStorage and decoded token
  useEffect(() => {
    try {
      const userRole = localStorage.getItem("userRole") || "";
      const userPermissions = localStorage.getItem("userPermissions") || "";

      let tokenUserType = "";
      if (token) {
        try {
          const decodedToken = JSON.parse(atob(token.split(".")[1]));
          tokenUserType = decodedToken["custom:user_type"] || "";
        } catch (e) {
          console.error("Error decoding token:", e);
        }
      }

      const isAdminUser =
        userRole?.toLowerCase() === "admin" ||
        userPermissions?.toLowerCase().includes("admin") ||
        tokenUserType?.toLowerCase() === "admin";

      console.log("=== COMPANIES ADMIN CHECK ===");
      console.log("User Type (from token):", tokenUserType);
      console.log("User Type (from Companies.jsx):", usertype);
      console.log("Is Admin:", isAdminUser);
      console.log("==============================");

      setIsAdmin(isAdminUser);
    } catch (error) {
      console.error("Error checking admin status:", error);
      setIsAdmin(false);
    }
  }, [token]);

  console.log("login", usertype);
  console.log("company", company?.payload);

  const dispatch = useDispatch();

  const handledata = (e, data, index) => {
    e.preventDefault();
    setselectcompany(data);
    setIndex(index);
    setclick(true);
    navigate("/company-detail", { state: { data } });
  };

  const navigate = useNavigate();

  const handleEdit = (data) => {
    navigate("/add-company", { state: { data } });
  };

  const handleDelete = (data) => {
    console.log(data?.id);
    setloading(true);
    dispatch(deletemycompany({ id: data?.id })).then((res) => {
      console.log("res", res);

      if (res?.meta.requestStatus === "fulfilled") {
        const payload = {
          page: page,
        };
        dispatch(mycompanies(payload))
          .then((data) => {
            setcompany(data);
            setloading(false);
            toast.success(res?.payload);
          })
          .catch((err) => console.error(err));
      } else {
        toast.error(res?.payload);
      }
    });
  };

  const handleclose = () => {
    setclick(false);
  };

  const handleprevious = () => {
    setpage(page - 1 !== 0 ? page - 1 : 1);
  };

  const handlenext = () => {
    if (Array.isArray(company?.payload) && company?.payload?.length === 30) {
      setpage(page + 1);
    }
  };

  const handlenext1 = () => {
    if (Array.isArray(company?.payload) && company?.payload?.length === 10) {
      setpage(page + 1);
    }
  };

  const [filterData, setFilterData] = useState(null);

  useEffect(() => {
    if (!myCompanyRoute) {
      dispatch(dropDowns()).then((res) => {
        setFilterData(res.payload);
      });
    }
  }, []);

  const [filterPayload, setFilterPayload] = useState({});

  const [userCurrentLocation, setUserCurrentLocation] = useState({
    x: -1,
    y: -1,
  });
  const [apicall, setapicall] = useState(false);

  const handleReject = (company_id) => {
    setloading(true);
    console.log("reject id", company_id);
    const params = {
      company_id,
      action: "reject",
    };
    console.log("params", params);

    dispatch(companyapproval(params)).then((response) => {
      console.log("response", response.payload);
      setloading(false);
      setapicall(true);
      toast.success(response.payload);
    });
  };

  const handleApprove = (company_id) => {
    setloading(true);
    console.log("reject id", company_id);
    const params = {
      company_id,
      action: "approve",
    };
    console.log("params", params);

    dispatch(companyapproval(params)).then((response) => {
      console.log("response", response.payload);
      setloading(false);
      setapicall(true);
      toast.success(response.payload);
    });
  };

  useEffect(() => {
    setloading(true);

    if (myCompanyRoute) {
      const payload = {
        page: page,
      };
      dispatch(mycompanies(payload))
        .then((data) => {
          setcompany(data);
          setloading(false);
        })
        .catch((err) => {
          console.error(err);
          setloading(false);
        });
    } else {
      const payload = {
        page_size: 30,
        page: page,
        filters: {
          products_produced: filterPayload?.products_produced,
          products_purchased: filterPayload?.products_purchased,
          species: filterPayload?.species,
          company_name: filterPayload?.company_name,
          region: filterPayload?.region,
          equipments: filterPayload?.equipments,
          residue: filterPayload?.residue,
          services: filterPayload?.services,
          accept_bid_logs: filterPayload?.accept_bid_logs,
          certifications: filterPayload?.certifications,
          state: filterPayload?.state,
        },
        x: userCurrentLocation?.x,
        y: userCurrentLocation?.y,
      };
      dispatch(!user ? companies(payload) : companies_non_mask(payload))
        .then((data) => {
          setcompany(data);
          setloading(false);
        })
        .catch((err) => {
          console.error(err);
          setloading(false);
        });
    }
  }, [page, filterPayload, userCurrentLocation, apicall]);

  const filter = (filterData) => {
    setFilterPayload(filterData);
  };

  const [showMore, setShowMore] = useState(false);

  const [border, setBorder] = useState(null);
  const highLighData = (address) => {
    setBorder(address);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [click]);

  const cardRefs = useRef([]);
  useEffect(() => {
    if (!myCompanyRoute) {
      if (Array.isArray(company?.payload)) {
        company.payload.forEach((data, index) => {
          if (
            border ===
              `${data?.address}, ${data?.city}, ${data?.state}, ${data?.zip}` &&
            cardRefs.current[index]
          ) {
            cardRefs.current[index].scrollIntoView({
              behavior: "smooth",
              block: "start",
            });
          }
        });
      }
    }
  }, [border, company?.payload]);

  const [map, setmap] = useState(false);
  const [isCollapseOpen, setIsCollapseOpen] = useState(false);

  const handleToggle = (type) => {
    if (map === type && isCollapseOpen) {
      setIsCollapseOpen(false);
      setTimeout(() => setmap(null), 300);
    } else {
      setmap(type);
      setIsCollapseOpen(true);
    }
  };

  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [isMobile1, setIsMobile1] = useState(window.innerWidth <= 991);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
      setIsMobile1(window.innerWidth <= 991);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // -------------------------
  // Bulk Upload/Download functionality
  // -------------------------
  const fileInputRef = useRef(null);
  const [uploading, setUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [uploadStatus, setUploadStatus] = useState("idle");
  const [uploadMessage, setUploadMessage] = useState("");
  const [failedRows, setFailedRows] = useState([]);

  const apiBase = (process.env.REACT_APP_API_URL || "").replace(/\/$/, "");
  const buildUrl = (path) => (apiBase ? `${apiBase}${path}` : path);

  const axiosConfig = {
    headers: token
      ? {
          Authorization: `Bearer ${token}`,
        }
      : {},
  };

  // Bulk download
  const handleBulkDownload = async (
    userFilters = {},
    visibleCompanies = []
  ) => {
    if (!isAdmin) {
      toast.error("You do not have permission to export data.");
      return;
    }

    try {
      setloading(true);

      if (Array.isArray(visibleCompanies) && visibleCompanies.length > 0) {
        try {
          const ws_data = [];

          const headers = [
            "Company Name",
            "Location",
            "State",
            "Region",
            "Species",
            "Equipments",
            "Products Produced",
            "Products Purchased",
            "Services",
            "Certifications",
          ];
          ws_data.push(headers);

          visibleCompanies.forEach((company) => {
            ws_data.push([
              company.name || "",
              company.location || "",
              company.state || "",
              company.region || "",
              (company.species && company.species.join(", ")) || "",
              (company.equipments && company.equipments.join(", ")) || "",
              (company.products_produced &&
                company.products_produced.join(", ")) ||
                "",
              (company.products_purchased &&
                company.products_purchased.join(", ")) ||
                "",
              (company.services && company.services.join(", ")) || "",
              (company.certifications && company.certifications.join(", ")) ||
                "",
            ]);
          });

          const XLSX = await import("xlsx").then((m) => m.default);
          const ws = XLSX.utils.aoa_to_sheet(ws_data);
          const wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, ws, "Companies");

          const timestamp = new Date().toISOString().slice(0, 10);
          const filename = `filtered_companies_${timestamp}.xlsx`;

          XLSX.writeFile(wb, filename);
          toast.success(
            `Downloaded ${visibleCompanies.length} filtered companies`
          );
          setloading(false);
          return;
        } catch (err) {
          console.error("Failed to create Excel file:", err);
        }
      }

      const filters = {
        company_name: userFilters.company_name || null,
        state: userFilters.state || null,
        species: userFilters.species || null,
        region: userFilters.region || null,
        equipments: userFilters.equipments || null,
        products_produced: userFilters.products_produced || null,
        products_purchased: userFilters.products_purchased || null,
        accept_bid_logs: userFilters.accept_bid_logs || null,
        services: userFilters.services || null,
        certifications: userFilters.certifications || null,
      };

      Object.keys(filters).forEach(
        (key) =>
          (filters[key] === null ||
            filters[key] === undefined ||
            filters[key] === "") &&
          delete filters[key]
      );

      // CORRECTED PAYLOAD - Use current page and filters
      const payload = {
        page_size: 30,
        page: page, // Use current page instead of hardcoded page 1
        filters,
        x:
          userCurrentLocation?.x !== undefined
            ? userCurrentLocation.x
            : userFilters.x !== undefined
            ? userFilters.x
            : -1,
        y:
          userCurrentLocation?.y !== undefined
            ? userCurrentLocation.y
            : userFilters.y !== undefined
            ? userFilters.y
            : -1,
      };

      const downloadUrl = buildUrl("/company/download");
      const res = await axios.post(downloadUrl, payload, {
        ...axiosConfig,
        responseType: "arraybuffer",
        validateStatus: (s) => true,
      });

      if (res.status < 200 || res.status >= 300) {
        const text = new TextDecoder("utf-8").decode(
          res.data || new ArrayBuffer(0)
        );
        if (text && text.trim().startsWith("http")) {
          window.open(text.trim(), "_blank");
          setloading(false);
          return;
        }
        toast.error("Bulk download failed: " + (text || `HTTP ${res.status}`));
        console.error("Bulk download error response:", text);
        setloading(false);
        return;
      }

      let parsedJson = null;
      try {
        const text = new TextDecoder("utf-8").decode(
          res.data || new ArrayBuffer(0)
        );
        parsedJson = JSON.parse(text);
      } catch (e) {
        parsedJson = null;
      }

      if (parsedJson) {
        const possible =
          parsedJson.download_url ||
          parsedJson.downloadUrl ||
          parsedJson.url ||
          parsedJson.signedUrl ||
          parsedJson.data?.url ||
          parsedJson.fileUrl ||
          parsedJson.download?.url;

        if (
          possible &&
          typeof possible === "string" &&
          possible.startsWith("http")
        ) {
          const filename = parsedJson.filename || parsedJson.name || null;
          if (filename) {
            const a = document.createElement("a");
            a.href = possible;
            a.setAttribute("download", filename);
            a.setAttribute("target", "_blank");
            document.body.appendChild(a);
            a.click();
            a.remove();
            toast.success(
              parsedJson.message || "Download started: " + filename
            );
          } else {
            window.open(possible, "_blank");
            toast.success(parsedJson.message || "Opening download link...");
          }
          setloading(false);
          return;
        }
      }

      try {
        const blob = new Blob([res.data], {
          type: res.headers["content-type"] || "application/octet-stream",
        });
        const objectUrl = window.URL.createObjectURL(blob);

        const disposition =
          res.headers["content-disposition"] ||
          res.headers["Content-Disposition"] ||
          "";
        let filename = "companies_bulk_download.xlsx";

        if (disposition) {
          const match = disposition.match(
            /filename\*=UTF-8''(.+)|filename="?([^"]+)"?/
          );
          if (match) filename = decodeURIComponent(match[1] || match[2]);
        } else if (parsedJson && parsedJson.filename) {
          filename = parsedJson.filename;
        }

        const link = document.createElement("a");
        link.href = objectUrl;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(objectUrl);
        toast.success(parsedJson?.message || "Download started: " + filename);
      } catch (err) {
        console.error("Failed to save file:", err);
        toast.error("Download succeeded but failed to save file. See console.");
      }
    } catch (err) {
      console.error("Bulk download error:", err);
      if (err?.message && err.message.includes("Network Error")) {
        toast.error(
          "Network Error: check backend URL / CORS / network. See console & Network tab."
        );
      } else {
        toast.error("Bulk download failed. See console for details.");
      }
    } finally {
      setloading(false);
    }
  };

  // Safe helper function to get payload as array
  const getCompaniesPayload = () => {
    if (Array.isArray(company?.payload)) {
      return company.payload;
    }
    return [];
  };

  const companiesPayload = getCompaniesPayload();
  const payloadLength = companiesPayload.length;

  // Helper function to check if a company is unverified
  // Show unclaimed indicators for all users (logged in and not logged in)
  const isUnverifiedCompany = (company) => {
    // Company is unverified if admin_verified is null/undefined OR company is not verified by email (is_verified_by_email is false)
    return (
      company.admin_verified === null ||
      company.admin_verified === undefined ||
      company.is_verified_by_email === false ||
      !company.is_verified_by_email
    );
  };

  return (
    <>
      {loading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "rgba(255, 255, 255, 0.7)",
            zIndex: 1000,
          }}
        >
          <CircularProgress style={{ color: "#4A5E00" }} />
        </div>
      )}

      <>
        <div className="d-flex w-100 position-relative">
          <div className="company-details-main">
            <div style={{ margin: "3em 2.2em 0em" }} className="com-div">
              <div
                style={{ marginBottom: "15px" }}
                className="d-flex justify-content-between rpf-title com"
              >
                <div
                  className="d-flex"
                  style={{
                    alignItems: "center",
                    marginLeft: "0.7em",
                    marginBottom: "1em",
                  }}
                >
                  <Typography variant="h5">
                    {myCompanyRoute ? "My Companies" : "All Companies"}
                  </Typography>
                </div>

                {/* EXPORT DATA BUTTON - ADMIN ONLY */}
                <div className="d-flex gap-2" style={{ flexWrap: "wrap" }}>
                  {isAdmin && (
                    <button
                      className="export-btn"
                      onClick={() =>
                        handleBulkDownload(filterPayload, companiesPayload)
                      }
                      style={{
                        padding: "0.35em 0.8em",
                        fontSize: "0.9rem",
                        backgroundColor: "transparent",
                        border: "1px solid #000",
                        color: "#000",
                        borderRadius: "4px",
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        gap: "0.4em",
                        transition: "all 0.2s ease",
                        fontWeight: "500",
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.backgroundColor = "rgba(0, 0, 0, 0.05)";
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.backgroundColor = "transparent";
                      }}
                    >
                      Export
                      <FiDownload style={{ fontSize: "1rem" }} />
                    </button>
                  )}
                </div>
              </div>

              {/* Upload progress indicator */}
              {uploading && (
                <div style={{ marginTop: 12, marginBottom: 12 }}>
                  <div style={{ marginBottom: 8 }}>
                    Uploading: {uploadProgress}%
                  </div>
                  <div
                    style={{
                      width: "100%",
                      height: "8px",
                      backgroundColor: "#e0e0e0",
                      borderRadius: "4px",
                      overflow: "hidden",
                    }}
                  >
                    <div
                      style={{
                        height: "100%",
                        backgroundColor: "#4A5E00",
                        width: `${uploadProgress}%`,
                        transition: "width 0.3s",
                      }}
                    />
                  </div>
                </div>
              )}

              {/* Upload status messages */}
              {uploadStatus === "success" && (
                <div
                  style={{
                    marginTop: 12,
                    padding: "12px",
                    backgroundColor: "#d4edda",
                    border: "1px solid #c3e6cb",
                    borderRadius: "4px",
                    color: "#155724",
                  }}
                >
                  <strong>✓ Success:</strong> {uploadMessage}
                </div>
              )}

              {uploadStatus === "error" && (
                <div
                  style={{
                    marginTop: 12,
                    padding: "12px",
                    backgroundColor: "#f8d7da",
                    border: "1px solid #f5c6cb",
                    borderRadius: "4px",
                    color: "#721c24",
                  }}
                >
                  <strong>✗ Error:</strong> {uploadMessage}
                </div>
              )}

              {/* Failed rows table */}
              {failedRows.length > 0 && (
                <div
                  style={{
                    marginTop: 12,
                    padding: "12px",
                    backgroundColor: "#fff3cd",
                    border: "1px solid #ffeaa7",
                    borderRadius: "4px",
                  }}
                >
                  <strong>Failed Rows ({failedRows.length}):</strong>
                  <table
                    style={{
                      width: "100%",
                      marginTop: "8px",
                      borderCollapse: "collapse",
                      fontSize: "0.9rem",
                    }}
                  >
                    <thead>
                      <tr style={{ borderBottom: "1px solid #ffc107" }}>
                        <th style={{ textAlign: "left", padding: "4px" }}>
                          Row
                        </th>
                        <th style={{ textAlign: "left", padding: "4px" }}>
                          Company Name
                        </th>
                        <th style={{ textAlign: "left", padding: "4px" }}>
                          Error
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {failedRows.map((err, idx) => (
                        <tr
                          key={idx}
                          style={{ borderBottom: "1px solid #ffc107" }}
                        >
                          <td style={{ padding: "4px" }}>{err.row}</td>
                          <td style={{ padding: "4px" }}>{err.company_name}</td>
                          <td style={{ padding: "4px", fontSize: "0.85rem" }}>
                            {err.error}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}

              {/* Hidden file input for upload */}
              <input
                ref={fileInputRef}
                type="file"
                accept=".xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                style={{ display: "none" }}
              />
            </div>

            <div
              className="d-flex companies-list overflow-hidden"
              style={{ margin: myCompanyRoute ? "2em 2em 2em 1.5em" : "" }}
            >
              {myCompanyRoute ? (
                <></>
              ) : !isMobile ? (
                <div className="map-width1">
                  <div style={{ width: "100%" }} className="map-width">
                    <AllMapAddress
                      addresses={companiesPayload}
                      highLighData={highLighData}
                      userCurrentLocation={userCurrentLocation}
                      setUserCurrentLocation={setUserCurrentLocation}
                    />
                  </div>

                  <div
                    style={{
                      marginTop: payloadLength > 0 ? "3em" : "0em",
                    }}
                  >
                    <Filter
                      data={filterData}
                      filter={filter}
                      setpage={setpage}
                    />
                  </div>
                </div>
              ) : (
                <>
                  <div className="d-flex flex-row justify-content-between">
                    <div>
                      <button
                        style={{ marginLeft: "15px" }}
                        className="mob-btn btn btn-primary"
                        type="button"
                        onClick={() => handleToggle("Filter")}
                      >
                        Filter
                      </button>

                      <button
                        style={{ marginLeft: "5px" }}
                        className="mob-btn1 btn btn-primary"
                        type="button"
                        onClick={() => handleToggle("Map")}
                      >
                        Map
                      </button>

                      <div
                        className={`collapse filter-bottom-to-top ${
                          isCollapseOpen ? "show" : ""
                        }`}
                        id="filterCollapse"
                      >
                        <div
                          className="card card-body"
                          style={{
                            padding: map === "Map" ? "0px" : "",
                            paddingBottom: map === "Map" ? "25px" : "",
                          }}
                        >
                          {map === "Map" ? (
                            <>
                              <AllMapAddress
                                addresses={companiesPayload}
                                highLighData={highLighData}
                                userCurrentLocation={userCurrentLocation}
                                setUserCurrentLocation={setUserCurrentLocation}
                              />
                            </>
                          ) : map === "Filter" ? (
                            <Filter
                              data={filterData}
                              filter={filter}
                              isMobile="true"
                              setpage={setpage}
                            />
                          ) : null}
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}

              {!myCompanyRoute ? (
                <div
                  className={`row card main-com ${
                    myCompanyRoute ? "col-12 m-card" : "company-list"
                  }`}
                  style={{
                    border: "none",
                    display: "ruby",
                    margin: payloadLength > 0 ? undefined : "0px !important",
                    width: payloadLength > 0 ? undefined : "100%",
                  }}
                >
                  {payloadLength > 0 ? (
                    companiesPayload.map((data, index) => {
                      const isUnverified = isUnverifiedCompany(data);
                      const companyColor = isUnverified ? "#FFD700" : "#A5BF45"; // Yellowish for unverified, green for verified
                      
                      return (
                        <div
                          key={index}
                          className="col-6 dynamic-list"
                          style={{
                            marginBottom: "1.5em",
                          }}
                        >
                          <div
                            className="d-flex"
                            style={{ alignItems: "center" }}
                          >
                            <Tooltip title={isUnverified ? "Unclaimed" : ""}>
                            <FaBuilding
                              style={{
                                  color: companyColor,
                                cursor: "pointer",
                                marginRight: "0.2em",
                                height: "1.5em",
                                width: "1.5em",
                              }}
                            />
                            </Tooltip>

                            <Typography>
                              {" "}
                              <Tooltip title={isUnverified ? "Unclaimed" : ""}>
                              <span
                                style={{
                                  textDecoration: "underline",
                                    color: companyColor,
                                  cursor: "pointer",
                                }}
                                onClick={(e) => handledata(e, data, index)}
                              >
                                {" "}
                                {data.name}
                                </span>
                              </Tooltip>{" "}
                              {data.city} , {data.state}{" "}
                            </Typography>
                          </div>
                        </div>
                      );
                    })
                  ) : (
                    <Typography style={{ textAlign: "center" }}>
                      No companies available.
                    </Typography>
                  )}

                  {payloadLength > 0 && (
                    <div
                      style={{
                        textAlign: "center",
                        background: "white",
                        padding: "20px",
                        margin: "1.5em 0",
                      }}
                    >
                      <span
                        style={{
                          cursor: page === 1 ? "not-allowed" : "pointer",
                          color: page === 1 ? "gray" : "black",
                          fontSize: "larger",
                        }}
                      >
                        {" "}
                        <FaAnglesLeft
                          style={{ marginRight: "1em" }}
                          onClick={handleprevious}
                        />{" "}
                      </span>

                      <span className="set-page-no">{page}</span>

                      <span
                        style={{
                          cursor:
                            payloadLength < 30 ? "not-allowed" : "pointer",
                          fontSize: "larger",
                          color: payloadLength < 30 ? "gray" : "black",
                        }}
                      >
                        <FaAnglesRight
                          style={{ marginLeft: "1em" }}
                          onClick={handlenext}
                        />
                      </span>
                    </div>
                  )}
                </div>
              ) : (
                <div
                  className={`row card main-com ${
                    myCompanyRoute ? "col-12 m-card" : "col-8"
                  }`}
                  style={{
                    border: "none",
                    display: "ruby",
                  }}
                >
                  {payloadLength > 0 ? (
                    companiesPayload.map((data, index) => {
                      // Only apply unclaimed logic if NOT myCompanyRoute
                      const isUnverified = !myCompanyRoute ? isUnverifiedCompany(data) : false;
                      const companyColor = isUnverified ? "#FFD700" : "#A5BF45"; // Yellowish for unverified, green for verified
                      // For myCompanyRoute, always use green color and lightgray border
                      const borderColor = myCompanyRoute 
                        ? (border === `${data?.complete_physical_address}` ? "#A5BF45" : "lightgray")
                        : (border === `${data?.complete_physical_address}`
                          ? companyColor
                          : isUnverified 
                          ? "#FFD700" 
                          : "lightgray");
                      
                      return (
                        <div
                          ref={(el) => (cardRefs.current[index] = el)}
                          key={index}
                          className={`col-6 inner-card p-0 card-com ${
                            myCompanyRoute ? "col-md-3" : "col-md-6"
                          }`}
                          style={{
                            border: `2px solid ${borderColor}`,
                            width: myCompanyRoute
                              ? ""
                              : showMore
                              ? "42%"
                              : "43%",
                            marginBottom: "2em",
                            marginLeft: "1em",
                            boxShadow: "0 4px 12px rgba(27,71,102,0.15)",
                            minHeight: "180px",
                            maxHeight: "auto",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "space-between",
                            alignItems: "stretch",
                          }}
                        >
                          <CardActionArea>
                            <div className="d-flex section-1 flex-column">
                              <div
                                style={{ padding: "0.7rem", cursor: "default" }}
                              >
                                <div>
                                  <div>
                                    <div className="d-flex justify-content-between">
                                      <div
                                        className="d-flex app-rej-btn"
                                        style={{
                                          flexWrap: "wrap",
                                          width: "265px",
                                          alignItems: "center",
                                        }}
                                      >
                                        {!myCompanyRoute ? (
                                          <Tooltip title={isUnverified ? "Unclaimed" : ""}>
                                        <span
                                          style={{
                                            fontWeight: "500",
                                            cursor: "pointer",
                                            margin: "0em 0.5em",
                                            whiteSpace: "nowrap",
                                                color: companyColor,
                                          }}
                                          onClick={(e) =>
                                            handledata(e, data, index)
                                          }
                                        >
                                          {data.name}
                                        </span>
                                          </Tooltip>
                                        ) : (
                                          <span
                                            style={{
                                              fontWeight: "500",
                                              cursor: "pointer",
                                              margin: "0em 0.5em",
                                              whiteSpace: "nowrap",
                                              color: "#A5BF45",
                                            }}
                                            onClick={(e) =>
                                              handledata(e, data, index)
                                            }
                                          >
                                            {data.name}
                                          </span>
                                        )}

                                        {/* Show "unclaimed" badge when company is unclaimed (only for non-myCompanyRoute) */}
                                        {!myCompanyRoute && isUnverified && (
                                          <div
                                            style={{
                                              display: "flex",
                                              alignItems: "center",
                                              gap: "0.2em",
                                            }}
                                          >
                                            <span
                                              style={{
                                                backgroundColor:
                                                  "rgba(255, 215, 0, 0.3)",
                                                padding: "0em 0.3em",
                                                borderRadius: "1em",
                                                color: "#B8860B",
                                              }}
                                            >
                                              unclaimed
                                            </span>

                                            {usertype === "admin" && (
                                              <>
                                                <Tooltip title="Approve">
                                                  <MdOutlineCheckCircle
                                                    style={{
                                                      height: "2em",
                                                      width: "2em",
                                                      cursor: "pointer",
                                                    }}
                                                    onClick={() =>
                                                      handleApprove(data?.id)
                                                    }
                                                  />
                                                </Tooltip>

                                                <Tooltip title="Reject">
                                                  <IoMdCloseCircleOutline
                                                    style={{
                                                      height: "2em",
                                                      width: "2em",
                                                      cursor: "pointer",
                                                    }}
                                                    onClick={() =>
                                                      handleReject(data?.id)
                                                    }
                                                  />
                                                </Tooltip>
                                              </>
                                            )}
                                          </div>
                                        )}
                                      </div>

                                      <div style={{ alignContent: "center" }}>
                                        {myCompanyRoute ? (
                                          <div className="d-flex">
                                            <FaEdit
                                              onClick={() => handleEdit(data)}
                                              style={{
                                                height: "1.5em",
                                                width: "1.5em",
                                                marginRight: "0.5em",
                                              }}
                                            />
                                            <RiDeleteBin6Fill
                                              onClick={() => handleDelete(data)}
                                              style={{
                                                height: "1.5em",
                                                width: "1.5em",
                                              }}
                                            />
                                          </div>
                                        ) : (
                                          <></>
                                        )}
                                      </div>
                                    </div>
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                      }}
                                    >
                                      <h6>
                                        <a
                                          href={
                                            data.company_contacts[0]?.website
                                          }
                                          style={{
                                            textDecoration: "none",
                                            color: "#707070",
                                          }}
                                          target="_blank"
                                          rel="noopener noreferrer"
                                        >
                                          {data.company_contacts[0]
                                            ?.website && (
                                            <img
                                              src={newTab}
                                              alt="newTab"
                                              height={"17px"}
                                              width={"17px"}
                                            />
                                          )}{" "}
                                        </a>
                                        {data.company_contacts[0]?.website}
                                      </h6>
                                    </div>
                                  </div>

                                  <div>
                                    <h6 style={{ display: "flex" }}>
                                      <a
                                        style={{
                                          textDecoration: "none",
                                          color: "#707070",
                                        }}
                                        href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
                                          `${data?.x},${data?.y}`
                                        )}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      >
                                        {data?.complete_physical_address && (
                                          <span
                                            style={{
                                              backgroundColor:
                                                "rgb(112, 112, 112)",
                                              color: "white",
                                              width: "21px",
                                              height: "21px",
                                              borderRadius: "50% 50% 50% 0",
                                              transform: "rotate(-45deg)",
                                              textAlign: "center",
                                              lineHeight: "22px",
                                              fontWeight: "bold",
                                              border: "2px solid white",
                                              fontSize: "14px",
                                              display: "inline-block",
                                            }}
                                          >
                                            <span
                                              style={{
                                                transform: "rotate(45deg)",
                                                display: "flex",
                                                paddingLeft: "3px",
                                                fontSize: "smaller",
                                              }}
                                            >
                                              {index + 1}
                                            </span>
                                          </span>
                                        )}
                                      </a>

                                      <span
                                        className="truncate-text"
                                        style={{
                                          display: "-webkit-box",
                                          WebkitBoxOrient: "vertical",
                                          overflow: "hidden",
                                          WebkitLineClamp: 3,
                                          whiteSpace: "normal",
                                          wordWrap: "break-word",
                                        }}
                                      >
                                        {data?.street_address}, {data?.city},{" "}
                                        {data?.state}, {data?.zip}
                                      </span>
                                    </h6>
                                  </div>

                                  <div>
                                    <h6 className="d-flex">
                                      <a
                                        href={`tel:${data?.company_contacts[0]?.phone}`}
                                        style={{
                                          textDecoration: "none",
                                          color: "#707070",
                                          display: "flex",
                                          alignItems: "center",
                                        }}
                                      >
                                        {data?.company_contacts[0]?.phone && (
                                          <i
                                            style={{ marginRight: "5px" }}
                                            className="fa fa-phone"
                                          ></i>
                                        )}
                                      </a>
                                      {data?.company_contacts[0]?.phone}{" "}
                                    </h6>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </CardActionArea>
                        </div>
                      );
                    })
                  ) : (
                    <Typography style={{ textAlign: "center" }}>
                      No companies available.
                    </Typography>
                  )}

                  {payloadLength > 0 && (
                    <div
                      style={{
                        textAlign: "center",
                        background: "white",
                        padding: "20px",
                        margin: "1.5em 0",
                      }}
                    >
                      <span
                        style={{
                          cursor: page === 1 ? "not-allowed" : "pointer",
                          color: page === 1 ? "gray" : "black",
                          fontSize: "larger",
                        }}
                      >
                        {" "}
                        <FaAnglesLeft
                          style={{ marginRight: "1em" }}
                          onClick={handleprevious}
                        />{" "}
                      </span>

                      <span className="set-page-no">{page}</span>

                      <span
                        style={{
                          cursor:
                            payloadLength < 10 ? "not-allowed" : "pointer",
                          fontSize: "larger",
                          color: payloadLength < 10 ? "gray" : "black",
                        }}
                      >
                        <FaAnglesRight
                          style={{ marginLeft: "1em" }}
                          onClick={handlenext1}
                        />
                      </span>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>

          {!isMobile1 && (
            <div
              id="sidemenu"
              className="sidemenu"
              style={{
                position: "absolute",
                right: "0",
                backgroundColor: "rgba(128, 128, 128, 0.15)",
                padding: "1em",
                height: "100%",
              }}
            >
              <MenuButton />
            </div>
          )}
        </div>
      </>
    </>
  );
}

export default Companies;
